import type {
  InvoicePossibleAssigneesQueryParams,
  InvoicePossibleAssigneesResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodInvoicePossibleAssigneesQueryParamsSchema,
  zodInvoicePossibleAssigneesResponseSchema,
} from './validations';

/**
 * Fetches users who can be assigned to an invoice, optionally narrowed by a
 * search term and a page window.
 *
 * @param queryParams - Invoice identifier, optional search term and page window.
 * @param options - Additional request options.
 * @returns Users with invoice access on the invoice owner company.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/list_possible_assignees_invoices__invoice_id__possible_assignees_get
 */
export async function fetchInvoicePossibleAssignees(
  { invoiceId, ...queryParams }: InvoicePossibleAssigneesQueryParams,
  options?: KyRequestOptions,
): Promise<InvoicePossibleAssigneesResponse> {
  return vestigasApi
    .get(ENDPOINT.INVOICE.GET_POSSIBLE_ASSIGNEES(invoiceId), {
      searchParams: queryParams,
      ...options,
      validate: {
        ...options?.validate,
        isResponseSensitive: true,
        response: zodInvoicePossibleAssigneesResponseSchema,
        searchParams: zodInvoicePossibleAssigneesQueryParamsSchema.transform(
          (data) => withoutObjectKeysWhereValueIs(data, [undefined, '']),
        ),
      },
    })
    .json<InvoicePossibleAssigneesResponse>();
}
